import axios from 'axios';
const baseURL = 'https://cms.quadbreak.com/backend/';
const imageUrl = 'https://cms.quadbreak.com/backend/api/storage/app/public/';
// const baseURL = 'http://localhost:8000/';
// const imageUrl = 'http://localhost:8000/storage/';

const api = axios.create({
  baseURL: `${baseURL}api/`,
  headers: {
    Accept: 'application/json'
  },
  withCredentials: true
});

// Add a request interceptor to add token and debug request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Handle FormData specifically
  if (config.data instanceof FormData) {
    // Remove Content-Type header to let browser set it
    // delete config.headers['Content-Type'];
  }

  // Debug request
  if (config.method === 'put' && config.url === '/settings') {
    console.log('Sending settings request:', {
      url: config.url,
      method: config.method,
      headers: config.headers,
      data: config.data
    });
  }

  return config;
}, (error) => {
  return Promise.reject(error);
});

// Add a response interceptor to handle errors and debug response
api.interceptors.response.use(
  (response) => {
    // Debug response
    if (response.config.method === 'put' && response.config.url === '/settings') {
      console.log('Settings response:', {
        status: response.status,
        data: response.data
      });
    }
    return response;
  },
  (error) => {
    if (error.response) {
      // Debug error response
      if (error.config.method === 'put' && error.config.url === '/settings') {
        console.error('Settings error response:', {
          status: error.response.status,
          data: error.response.data
        });
      }

      // Handle token expiration
      if (error.response.status === 401 && error.response.data.message === 'Unauthenticated.') {
        // Remove token and redirect to login
        localStorage.removeItem('token');
        window.location.href = '/login';
        return Promise.reject(error);
      }

      // Handle other errors
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

// Employee functions
export const getExpiringEmployees = (days = 15) => {
  return api.get(`/employees/expiring-soon/${days}`);
};


// const baseURL = 'http://localhost:8000/';
// const imageUrl = 'http://localhost:8000/storage/app/public/';

export { api as default, baseURL, imageUrl };
